module.exports = __webpack_public_path__ + "static/media/dndlogocolor.7f3fd7bb.jpg";